<template>
  <div
    :class="['tab-pane', 'fade', active ? 'active show' : '']"
    :id="id"
    :aria-labelled-by="ariaLabelledBy"
    role="tabpanel"
  >
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'TabContentItem',
  props: {
    active: {
      type: Boolean,
      default: false
    },
    id: {
      type: String,
      default: ''
    },
    ariaLabelledBy: {
      type: String,
      default: ''
    }
  }
}
</script>

